<template>
    <edit-base-template 
            v-on:update='updateItem()'
            v-on:create='createItem()'
            v-on:cancel='cancelEdit()'
            v-on:delete='deleteItem()'
            :item='item' 
            :errors='errors' 
            :title='formTitle()'
            :candelete='true'
            :inline_errors='["writeback_user_id"]'
            :ref="'editBase'">
        
        <template v-slot:body>
            <div class="form-group">
                <label for='name'>{{ $t('translations.title') }}</label>
                <input type='text' v-model='item.title' class='form-control'>
            </div>

            <div class="form-group">
                <label for='name'>{{ $t('translations.position') }}</label>
                <input type='number' v-model='item.position' min='1' step='1' class='form-control'>
            </div>

            
            <div class="form-group">
                <label>{{ $t('translations.custom_action_type') }}</label>
                <input v-on:change='change_action_type' type="radio" id="url" value="url" v-model="custom_action_type" />
                <label for="url">{{ $t('translations.url') }}</label>

                <input v-on:change='change_action_type' type="radio" id="form" value="form" v-model="custom_action_type" />
                <label for="form">{{ $t('translations.form') }}</label>
            </div>

            
            <div v-if='custom_action_type == "url"' class="form-group">
                <label for='url'>{{ $t('translations.url') }}</label>
                <input name="url" type='text' v-model='item.url' class='form-control'>
            </div>

            <template v-else-if='custom_action_type == "form"'>
                <div class="form-group">
                    <label for='form'>{{ $t('translations.form') }}</label>
                    <select class="form-control" v-model='item.form_id' name="form">
                        <option value="">-- {{ $t('translations.none') }} --</option>
                        <option :value='item.id' v-for='(item) in forms' :key='item.id'>
                            {{item.title}}
                        </option>
                    </select>
                </div>

                

                <div class="form-group">
                    <label for='name'>{{ autobrand('translations.automatically_assign_requests_to')}}:</label>
                    <select class='form-control' v-on:change='setAssignee($event)' v-model='ug_assign'>
                        <option value="">-- {{ $t('translations.do_not_automatically_assign')}} --</option>
                        <template v-for='(user) in $root.lookup.staff' >
                            <option :key='"u" + user.id' :value='"u" + user.id'>
                                {{ formatNameCompliant(user) }}
                            </option>
                        </template>
                        <template v-for='(group) in $root.lookup.user_groups'>
                            <option :key='"g" + group.id' :value='"g" + group.id'>
                                {{ $t('translations.group')}}: {{group.name}}
                            </option>
                        </template>
                    </select>
                </div>

                <div class="form-group">
                    <label for='name'>{{ autobrand('translations.automatically_tag_requests_as')}}:</label>
                    <template v-if='item.tag_id'>
                        <br />
                        <div class='icon-preview'>
                            <div class='search-lozenge badge badge-primary badge-pill' :style="{'background-color': getTag(item.tag_id).colour}">
                                <i :class='"pr-1 fa fa-lg fa-" + getTag(item.tag_id).icon' /> {{ getTag(item.tag_id).name }}
                            </div>
                        </div>
                        <button class='btn btn-round btn-primary btn-sm' v-on:click='item.tag_id = null'>{{ $t('translations.clear')}}</button>
                    </template>
                    <autocomplete class='align-self-stretch form-control'
                                v-model='item.tag_id'
                                ref='ac2'
                                :source="$root.lookup.tags"
                                @clear='tag = null'
                                :resultsDisplay='tagResultDisplay'
                                :request-headers="authHeaders"
                                @selected='setDisplayValue2'
                                @close='setDisplayValue2'
                                :placeholder="$t('translations.search_for_a_tag')"
                            >
                    </autocomplete>
                </div>

                <div class="form-group">
                    <label>{{ autobrand('translations.submission_message') | capitalise }} <span class="required-field">*</span></label>
                    <textarea class="new-message new-message-practice p-1" v-model="item.completion_message" 
                    id="completion_message_textarea" type="textarea"></textarea>
                    
                    <!-- <textarea v-on:keyup.enter.exact="processMessage"  :class='"new-message p-1" + (internal_message ? " list-message-internal" : "")' v-model="new_message" type="textarea"  v-text='new_message'></textarea> -->
                    <p class='chars-left' aria-live="polite">{{responseMessageCharactersLeft}}</p>
                    <preset-message-select 
                        targetId='completion_message_textarea' 
                        @select='item.completion_message = $event.text'>
                        </preset-message-select>
                    <inline-error v-bind:errors='errors' type='completion_message'></inline-error>
                </div>

                <div v-if='$root.provider.provider_provider_xref.length' class="form-group">
                    <label for='name'>{{ autobrand('translations.automatically_share_requests_with')}}:</label>
                    <select class='form-control' v-model='item.shared_provider_id'>
                        <option value="">-- {{ $t('translations.do_not_automatically_transfer')}} --</option>
                        <option v-for='(provider_provider_xref) in sortByValue($root.provider.provider_provider_xref, "name", "relation")' :key='provider_provider_xref.relation_id' :value='provider_provider_xref.relation_id'>
                            {{ provider_provider_xref.relation.name }}
                        </option>
                        
                    </select>
                </div>

                <div class="form-group">
                    <label for='autocomplete'>{{ $t('translations.autocomplete_custom_action')  | capitalise }}: </label>
                    <div>
                        <b-form-checkbox v-model="item.autocomplete" name="autocomplete" switch></b-form-checkbox>
                    </div>
                    <small>
                        {{ autobrand('translations.autocomplete_custom_action_info') }}
                    </small>
                </div>

                <template v-if='$root.provider.record_system_integration_type_id == 1'>
                    <inline-error type='writeback_user_id'></inline-error>
                    <div class="form-group">
                        <label for='name'>{{ autobrand('translations.when_shared_completes_automatically_or_autocompletes_writeback_with_user')}}:</label>
                        <select class='form-control' v-model='item.writeback_user_id'>
                            <option value="">-- {{ $t('translations.do_not_automatically_writeback')}} --</option>
                            <template v-for='(user) in $root.lookup.staff'>
                                <option v-if='user.provider.mrs_user_id' :key='user.id' :value='user.id'>
                                    {{ formatNameCompliant(user) }}
                                </option>
                            </template>
                        </select>
                    </div>
                </template>

                <div v-show='Array.isArray(feedback_forms) && feedback_forms.length > 1' class="form-group">
                    <label for='form'>{{ $t('translations.feedback_form') | capitalise }}</label>
                    <select class="form-control" v-model='item.feedback_form_id' name="form">
                        <option :value='item.id' v-for='(item) in feedback_forms' :key='item.id'>
                            {{item.title}}
                        </option>
                    </select>
                </div>

                
            </template>

            <div class="form-group">
                <label for='user_selectable'>{{ autobrand('translations.user_selectable')  | capitalise }}: </label>
                <div>
                    <b-form-checkbox v-on:change='change_user_selectable' v-model="item.user_selectable" name="user_selectable" switch></b-form-checkbox>
                </div>
            </div>
            <template v-if='item.user_selectable'>

                <div class="form-group">
                    <label for='name'>{{ $t('translations.icon') }}</label>
                    <!-- <input type='text' v-model='item.icon' class='form-control'> -->
                    <template v-if='item.icon'>
                        <br />
                        <div class='icon-preview'>
                            <i v-if='item.icon' :class='"fa fa-2x fa-" + item.icon'></i>
                        </div>
                        <button class='btn btn-round btn-primary btn-sm ' v-on:click='item.icon = null'>{{ $t('translations.clear') }}</button>
                    </template>
                    <autocomplete class='form-control'
                            ref='ac'
                            v-model='item.icon' 
                            source="/api/v1/icons?search="
                            results-property="data"
                            results-value="name"
                            @clear='item.icon = null'
                            :resultsDisplay='iconResultDisplay'
                            :request-headers="authHeaders"
                            @selected='setDisplayValue'
                            @close='setDisplayValue'
                            placeholder='Search for an icon'>
                    </autocomplete>
                    <!-- v-on:change='updateFilterValue' -->      
                </div>

                <div class="form-group" v-if='item.title && item.user_selectable'>
                    <label for='name'>{{ $t('translations.preview') }}</label><br />
                    <div class='card-button w-100 mb-2'>
                    <div class="card-icon"> <i v-if='item.icon' :class='"pr-1 fa fa-lg fa-" + item.icon'></i></div>
                    <div><h2>{{ item.title }}</h2></div>
                    </div>
                </div>

                <div v-if='item.user_selectable' class="form-group">
                    <label for='allow_out_of_hours'>{{ $t('translations.availability')  | capitalise }}: </label>
                    <select class='form-control' v-model="item.allow_out_of_hours" name="allow_out_of_hours" >
                        <option value="0">{{ $t('translations.availability_same_as_provider') }}</option>
                        <option value="1">{{ $t('translations.availability_always') }}</option>
                        <option value="2">{{ $t('translations.availability_custom') }}</option>
                    </select>
                </div>
                <availability-edit v-if='item.allow_out_of_hours == 2' :item="item"></availability-edit>    
            </template>
            <div class="form-group">
                <label for='name'>{{ $t('translations.patient_availability_filter') | capitalise }}</label>
                <component-filter-list :value="item.component_filter" :editable="true" />
            </div>
        </template>
    </edit-base-template>
</template>

<script>
	export default {
        extends: app.base.editBase,
		props: [
		],
		data: function(){
			return {
                title: 'Custom Action',
                event: "custom_action",
                model: "custom_action",
                elementname: "Custom Action",
                route: '/api/v1/custom_actions',
                forms: [],
                feedback_forms: [],
                auto_tag: null,
                ug_assign: null,
                custom_action_type: 'form',
                item: {
                    title: "",
                    position: null,
                    icon: "",
                    assigned_user_id: null,
                    assigned_group_id: null,
                    form_id: null,
                    tag_id: null,
                    url: null,
                    allow_out_of_hours: 0,
                    completion_message: "",
                    shared_provider_id: null,
                    writeback_user_id: null,
                    user_selectable: false,
                    availability_date: [],
                    feedback_form_id: null,
                    component_filter: [],
                },
			};
		},
        
        computed: {
            icons() {
                return this.arrayToAutocomplete(this.$root.fontawesome);
            },
            authHeaders () {
                return {
                    'Authorization': axios.defaults.headers.common['Authorization'],
                    'X-Api-Version': axios.defaults.headers.common['X-Api-Version']
                }
            },
            responseMessageCharactersLeft() {
				var char = this.item.completion_message ? this.item.completion_message.length : 0;
				var limit = 2048;

				if(char > limit) {
					this.completion_message = this.completion_message.substr(0, limit);
					char = this.completion_message.length;
				}
				return (limit - char) + " " + this.$t('translations.characters_remaining');
			},
            
        },
        mounted() {
            var search = encodeURIComponent(JSON.stringify(
                [{
                    field: "form_type_id",
                    type: "=",
                    value: 1
                }]
            ));

            axios.get(`/api/v1/forms?p=0&search=${search}`, {}).then((res) => {
                this.forms = res.data.data;
            }).catch((error) => {
                this.handleError(error, "read");
            });

            var search = encodeURIComponent(JSON.stringify(
                [{
                    field: "form_type_id",
                    type: "=",
                    value: 2
                }]
            ));

            axios.get(`/api/v1/forms?p=0&search=${search}`, {}).then((res) => {
                this.feedback_forms = res.data.data;
                if(Array.isArray(this.feedback_forms) && this.feedback_forms.length == 1) {
                    this.item.feedback_form_id = this.feedback_forms[0].id;
                }
            }).catch((error) => {
                this.handleError(error, "read");
            });
        },
        watch: {
            
        },
        methods: {
            getName() {
                return this.item.title;
            },
            change_user_selectable() {
                if(this.item.user_selectable) {
                    this.item.icon = null;
					if(Array.isArray(this.feedback_forms) && this.feedback_forms.length == 1) {
						this.item.feedback_form_id = this.feedback_forms[0].id;
					}
                    //this.item.allow_out_of_hours = 0;
                }
            },
            change_action_type() {
                if(this.custom_action_type == "url") {
                    this.item.form_id = null;
                    this.item.feedback_form_id = null;
                    this.item.assigned_group_id = null;
                    this.item.assigned_user_id = null;
                    this.item.tag_id = null;
                    this.auto_tag = null;
                    this.ug_assign = null;
                    this.completion_message = "";
                    this.shared_provider_id = null;
                    this.writeback_user_id = null;
                }
                else {
                    this.item.url = null;
                }
				if(Array.isArray(this.feedback_forms) && this.feedback_forms.length == 1) {
					this.item.feedback_form_id = this.feedback_forms[0].id;
				}
            },
            loadItem(id) {
                this.setLoading(true);
                axios.get(this.route + '/' + id ).then((res) => {
                    this.item = res.data[this.model];
                    // Annoying checkbox toggles
                    //this.item.allow_out_of_hours = this.item.allow_out_of_hours ? true : false;
                    this.item.user_selectable = this.item.user_selectable ? true : false;
                    this.item.autocomplete = this.item.autocomplete ? true : false;
                    this.custom_action_type = this.item.url ? 'url' : 'form';
                    if(this.item.assigned_user_id) {
                        this.ug_assign = "u" + this.item.assigned_user_id;
                    }
                    else if(this.item.assigned_group_id) {
                        this.ug_assign = "g" + this.item.assigned_group_id;
                    }
                    if(!this.item.component_filter) {
                        this.item.component_filter = [];
                    }
                    this.originalData = JSON.parse(JSON.stringify(this.item));
                    this.setLoading(false);
                }).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "load");
                    this.$router.push({path: "/" + this.event + "-list"});
                });
            },
            resetItem() {
                this.custom_action_type = 'form';
                this.item = {
                    title: "",
                    position: null,
                    icon: "",
                    assigned_user_id: null,
                    assigned_group_id: null,
                    form_id: null,
                    tag_id: null,
                    url: null,
                    allow_out_of_hours: false,
                    completion_message: "",
                    shared_provider_id: null,
                    writeback_user_id: null,
                    user_selectable: false,
                    autocomplete: false,
                    availability_date: [],
                    feedback_form_id: null,
                    component_filter: [],
                };

                if(Array.isArray(this.feedback_forms) && this.feedback_forms.length == 1) {
                    this.item.feedback_form_id = this.feedback_forms[0].id;
                }

                this.auto_tag = null;
                this.errors = [];
                this.originalData = JSON.parse(JSON.stringify(this.item));
            },
            setDisplayValue() {
                Vue.nextTick(() => {this.$refs.ac.display = this.$refs.ac.value});
            },
            setDisplayValue2() {
                Vue.nextTick(() => {
                    if(this.$refs.ac2.value) {
                        var tag = this.$root.lookup.tags.find(obj => {return obj.id == this.$refs.ac2.value});
                        if(tag) {
                            this.auto_tag = tag;
                            this.$refs.ac2.display = "";
                        }
                    }
                });
            },
            iconResultDisplay(item) {
                //console.info(item);
                return "<i class='fa fa-lg fa-" + item.name + "'></i><span class='ml-2'>" + item.name + "</span>";
            },
            setAssignee(event) {
                if(!event.target.value) {
                    this.item.assigned_user_id = null
                    this.item.assigned_group_id = null;
                }
                else if(event.target.value[0] == 'u') {
                    this.item.assigned_user_id = event.target.value.substr(1);
                    this.item.assigned_group_id = null;
                }
                else if(event.target.value[0] == 'g') {
                    this.item.assigned_user_id = null
                    this.item.assigned_group_id = event.target.value.substr(1);
                }
                else {
                    
                }
            },

        }

    }
</script>
